export function getPhoneValidationEndpoint(): string {
    return '/phone-number/validate';
}
